export default "__VITE_ASSET__V4ru_EmM__"